import React from 'react'
import { styled } from '@mui/material/styles'
import Paper from '@mui/material/Paper'
import Grid from '@mui/material/Grid'
import FormatClearIcon from '@mui/icons-material/FormatClear'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import cloneDeep from 'lodash/cloneDeep'
import { useSelector, useDispatch } from 'react-redux'
import { SelectUnit } from './types'
import { actions } from './reducer'
import {
  getSelectedUnits,
  getUnits,
  getUnitsClimate,
  getUnitsCovered,
} from './selectors'
import { UnitsCardComponent } from './UnitsCard'
import { ActionsDivComponent } from '../Register/Actions'
import { useDimensions } from '../../hooks/useDimensions'
import { SelectUnitsCallbacks } from './hooks/callbacks'
import { actions as registerActions } from '../Register/reducer'
import { getUnitsMaster } from '../Units/selectors'

const PaperComponent = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  backgroundColor: theme.palette.grey['900'],
}))

export const SelectUnitsComponent: React.FC = () => {
  const dispatch = useDispatch()
  const { width } = useDimensions()
  const unitsMaster = useSelector(getUnitsMaster)
  const units = useSelector(getUnits)
  const unitsClimate = useSelector(getUnitsClimate)
  const unitsCovered = useSelector(getUnitsCovered)
  const selectedUnits = useSelector(getSelectedUnits) as SelectUnit[]

  React.useEffect(() => {
    const _unitsMaster = cloneDeep(unitsMaster)
    if (_unitsMaster) {
      const data = _unitsMaster.map((v: any) => ({
        ...v,
        ...{ value: '0' },
      })) as SelectUnit[]
      const units = data.filter((x) => !x.isClimate && !x.isCovered)
      const unitsClimate = data.filter((x) => x.isClimate)
      const unitsCovered = data.filter((x) => x.isCovered)

      dispatch(actions.onResetSelected())
      dispatch(actions.onAllUnits({ units, unitsClimate, unitsCovered }))
    }
  }, [unitsMaster, dispatch])

  const { onChange } = SelectUnitsCallbacks()

  const onActiveStep = React.useCallback(() => {
    dispatch(registerActions.onActiveStep(3))
  }, [dispatch])

  return (
    <PaperComponent variant="outlined">
      <Grid container rowSpacing={2} spacing={2}>
        <Grid item xs={12} md={6} lg={4}>
          <UnitsCardComponent
            onChange={onChange}
            title="Non Climate"
            items={units}
            width={width}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <UnitsCardComponent
            onChange={onChange}
            title="Climate Controlled"
            items={unitsClimate}
            width={width}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <UnitsCardComponent
            onChange={onChange}
            title="Covered"
            items={unitsCovered}
            width={width}
          />
        </Grid>
      </Grid>
      <br />
      <ActionsDivComponent
        hideLeft
        onActionLeft={console.log}
        leftIcon={<FormatClearIcon />}
        textLeft="Reset"
        colorLeft="error"
        leftVariant="outlined"
        onActionRight={onActiveStep}
        rightIcon={<NavigateNextIcon />}
        textRight="Next"
        colorRight="primary"
        rightVariant="contained"
        disabledRight={selectedUnits.length === 0}
      />
    </PaperComponent>
  )
}
